import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=375adee7&"
import script from "./Classify.vue?vue&type=script&lang=js&"
export * from "./Classify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports